function copyToClipBoard(id) {
    // NOSONAR
    try {
        const copyLink = document.getElementById(id);
        copyLink.disabled = false;
        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            const editable = copyLink.contentEditable;
            const { readOnly } = copyLink;
            copyLink.contentEditable = true;
            copyLink.readOnly = false;
            const range = document.createRange();
            range.selectNodeContents(copyLink);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            copyLink.setSelectionRange(0, 999999);
            copyLink.contentEditable = editable;
            copyLink.readOnly = readOnly;
        } else {
            copyLink.select();
        }
        const isCopied = document.execCommand('copy');
        copyLink.disabled = true;
        return isCopied;
    } catch (err) {
        return false;
    }
}
export default copyToClipBoard;
